// Maps a 0–100 compliance/confidence score to a Tailwind text-color class,
// theme-aware. Shared so any score/status display renders consistently.
export const complianceScoreColor = (
  score: number | undefined,
  isDark: boolean,
): string => {
  if (typeof score !== 'number') return isDark ? 'text-slate-400' : 'text-slate-500';
  if (score >= 80) return isDark ? 'text-emerald-400' : 'text-emerald-600';
  if (score >= 60) return isDark ? 'text-amber-400' : 'text-amber-600';
  return isDark ? 'text-rose-400' : 'text-rose-600';
};
